var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor_panel-tab"},[_c('keep-alive',[_c(_vm.activeTab,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }